export default "__VITE_ASSET__173c063e__"